import styled from '@emotion/styled';

const Labels = styled.div`
  display: flex;
  align-items: baseline;
`;

export default Labels;
